import api from '../api'

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export async function getAllows() {
  return api.get('traceability_production_reports/allows');
}

export async function list(description, numOfRegisters = 10, page = 1, order, initialDate, finalDate) {
  const params = {
    order: order ? order : 'description',
  }
  if (description) {
    params.query = description.trim(); 
  }
  if (initialDate) {
    params.initialDate = formatDate(initialDate);
  }
  if (finalDate) {
    params.finalDate = formatDate(finalDate);
  }

  return api.get('traceability_production_reports', {
    params,
    headers: {
      registerperpage: numOfRegisters,
      page
    }
  });
}

export async function getTraceabilityProductionReport(lot) {
  return api.get(`traceability_production_reports/${lot}`);
}

export async function getPalletContent(palletIdentifer) {
  return api.get(`traceability_production_reports/pallet/${encodeURIComponent(palletIdentifer)}`);
}